import { gql } from '@apollo/client';

export const LOG_INCIDENT = gql`
  mutation LogIncident($data: LogIncidentInput!) {
    logIncident(data: $data) {
      message
    }
  }
`;

export const INCIDENT_ARCHIVE = gql`
  mutation SetIncidentArchiveStatus(
    $where: AttendanceIncidentWhereUniqueInput!
    $isArchived: Boolean!
    $reason: String!
  ) {
    setIncidentArchiveStatus(
      where: $where
      isArchived: $isArchived
      reason: $reason
    ) {
      message
      data {
        id
      }
    }
  }
`;

export const INCIDENT_EXCUSE = gql`
  mutation SetIncidentExcuseStatus(
    $where: AttendanceIncidentWhereUniqueInput!
    $isExcused: Boolean!
    $reason: String
  ) {
    setIncidentExcuseStatus(
      where: $where
      isExcused: $isExcused
      reason: $reason
    ) {
      message
      data {
        id
      }
    }
  }
`;

export const BULK_INCIDENT_EXCUSE = gql`
  mutation BulkSetIncidentExcuseStatus(
    $where: AttendanceIncidentsWhereInput!
    $isExcused: Boolean!
    $reason: String
  ) {
    bulkSetIncidentExcuseStatus(
      where: $where
      isExcused: $isExcused
      reason: $reason
    ) {
      message
    }
  }
`;

export const BULK_INCIDENT_ARCHIVE = gql`
  mutation BulkSetIncidentArchiveStatus(
    $where: AttendanceIncidentsWhereInput!
    $isArchived: Boolean!
    $reason: String
  ) {
    bulkSetIncidentArchiveStatus(
      where: $where
      isArchived: $isArchived
      reason: $reason
    ) {
      message
    }
  }
`;
